//dependencias
import React, { Component } from 'react';

//componentes
import TiposAreaAction from './tiposArea'

class Index extends Component {

    render(){
        return(
            <div>
                <TiposAreaAction />
            </div>
        );
    }

}
export default Index;